import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => useContext(LanguageContext);

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        return localStorage.getItem('slano-lang') || 'en';
    });

    const handleSetLang = (code) => {
        localStorage.setItem('slano-lang', code);
        setLang(code);
    };

    return (
        <LanguageContext.Provider value={{ lang, setLang: handleSetLang }}>
            {children}
        </LanguageContext.Provider>
    );
};